import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';

import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';
import { InquiryCard } from './InquiryPanel';

// LeadInquiries: Interessenten am Objekt des Eigentümers – Anfragen aus Portalen und direkte Anfragen mit ihren
// Besichtigungen. Nur sichtbar, wenn es Anfragen gibt.
export function LeadInquiries({ leadId }: { leadId: string }) {
  const { project } = useProject();
  const papi = useProjectApi();
  const list = useQuery({ queryKey: projectKeys.inquiries(project.id, { lead_id: leadId }), queryFn: ({ signal }) => papi.inquiries({ lead_id: leadId }, signal) });
  if (!list.data || list.data.items.length === 0) return null;
  return (
    <section className="card" aria-labelledby="lead-inquiries-title">
      <h2 id="lead-inquiries-title">Interessenten ({list.data.items.length})</h2>
      {list.data.items.map((q) => (
        <div key={q.id}>
          <InquiryCard inquiry={q} />
          {q.ticket_id && (
            <p className="muted">
              <Link to={`/p/${project.key}/tickets/${q.ticket_id}`}>Aufgabe öffnen</Link>
            </p>
          )}
        </div>
      ))}
    </section>
  );
}
